import { Navigate, Outlet } from "react-router-dom";

export const PrivateRoute = (props: any) => {
  if (!props.user) {
    return <Navigate to={"/auth/login"} replace />;
  }
  return <Outlet />;
};
